import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nocode/nocode_production/frontend/src/app/[locale]/(application)/(main)/workflow-automation/templates/ExternalAutomations.tsx");
